import { render, staticRenderFns } from "./SoldoutCategory.vue?vue&type=template&id=0f9c547a&"
import script from "./SoldoutCategory.vue?vue&type=script&lang=ts&"
export * from "./SoldoutCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports